module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_green_de-eb6fe9482d22a490d176de186a6e9704.png";